'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global isEmpty*/
/*global strToDateEn*/
/*global incDate*/
/*global formatDateEn*/
/*global sprintf*/
/*global validateInputs*/
/*global services*/

function CatalogItemsBasket(containerID) {
    this.containerID = containerID;
    this.$container = null;

    this.init();
}

CatalogItemsBasket.prototype = $.extend({}, {
    construtor: 'CatalogItemsBasket',

    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;

        $('body').off('click', '#' + _this.containerID + ' .item-plan-multiday-interval--days-input .item-plan-multiday-interval__button label');
        $('body').on('click', '#' + _this.containerID + ' .item-plan-multiday-interval--days-input .item-plan-multiday-interval__button label', function clickSetUserMultidayInputClb() {
            if (!$(this).closest('.item-plan-intervals-prices-multi-choice').hasClass('item-plan-intervals-prices--interval')) {
                _this.setUserMultidayInput($(this).closest('.item-plan-multiday-interval'));
            }

            return false;
        });

        $('body').off('change', '#' + _this.containerID + ' .item-plan-intervals-prices-multi-choice .item-plan-interval input:not(:text)');
        $('body').on('change', '#' + _this.containerID + ' .item-plan-intervals-prices-multi-choice .item-plan-interval input:not(:text)', function changeSelectItemPlanIntervalClb() {
            if (!$(this).closest('.item-plan-intervals-prices-multi-choice').hasClass('item-plan-intervals-prices--multiday')) {
                // celodny rusi ostatni vyber
                if ($(this).closest('.item-plan-interval').hasClass('item-plan-interval-all-windows')) {
                  $(this).closest('.item-plan-intervals-prices-wrapper').find('.item-plan-interval').not('.item-plan-interval-all-windows').find('input:not(:text)').prop('checked', false);
                }
                _this.selectItemPlanInterval($(this).closest('.item-plan-interval'));
            } else {
                $(this).prop('checked', false);
            }
        });

        $('body').off('change', '#' + _this.containerID + ' .item-plan-multiday-interval input:not(:text)');
        $('body').on('change', '#' + _this.containerID + ' .item-plan-multiday-interval input:not(:text)', function changeSelectItemMultidayIntervalClb() {
            if (!$(this).closest('.item-plan-intervals-prices-multi-choice').hasClass('item-plan-intervals-prices--interval')) {
                _this.selectItemMultidayInterval($(this).closest('.item-plan-multiday-interval'));
            } else {
                $(this).prop('checked', false);
            }
        });

        $('body').off('change', '#' + _this.containerID + ' .item-plan-multiday-interval input:text');
        $('body').on('change', '#' + _this.containerID + ' .item-plan-multiday-interval input:text', function changeDaysItemMultidayIntervalClb() {
            if (!$(this).closest('.item-plan-intervals-prices-multi-choice').hasClass('item-plan-intervals-prices--interval')) {
                _this.changeItemMultidayDays($(this).closest('.item-plan-multiday-interval'));
            }
        });

        $('body').off('click', '#' + _this.containerID + ' .item-plan-interval-price-remove');
        $('body').on('click', '#' + _this.containerID + ' .item-plan-interval-price-remove', function clickRemoveItemPlanIntervalsClb() {
            _this.removeItemPlanIntervals($(this).closest('.item-plan-interval-price-wrapper'));

            return false;
        });

        $('body').off('click', '#' + _this.containerID + ' .item-wrapper:not(.item-wrapper-selected) .insert-into-basket');
        $('body').on('click', '#' + _this.containerID + ' .item-wrapper:not(.item-wrapper-selected) .insert-into-basket', function clickInsertIntoBasketClb() {       
            _this.addItemToBasket($(this).closest('.item-wrapper'));
            return false;
        });

        $('body').off('click', '#' + _this.containerID + ' .item-plan-interval-price-wrapper ');
        $('body').on('click', '#' + _this.containerID + ' .item-plan-interval-price-wrapper ', function clickSelectItemPlanIntervalPriceClb() {
            _this.highlightInsertIntoBasket($(this).closest('.item-wrapper'));
        });
         
        $('body').off('change', '#' + _this.containerID + ' .item-wrapper.item-wrapper-selected .item-plan-intervals-prices-single-choice.item-plan-intervals-prices-singleday input');
        $('body').on('change', '#' + _this.containerID + ' .item-wrapper.item-wrapper-selected .item-plan-intervals-prices-single-choice.item-plan-intervals-prices-singleday input', function changeIntervalClb() {
            _this.addItemToBasket($(this).closest('.item-wrapper'));
        });
        
        return _this;
    },

    //**************************************************************************

    setDate: function setDate(date) {
        var _this = this;

        _this.$container.find('input[name$="date"]').val(date).change();

        return _this;
    },

    highlightInsertIntoBasket: function highlightInsertIntoBasket($wrapper) {
        var _this = this;

        $wrapper.addClass('item-wrapper-preselected');

        return _this;
    },

    toggleHighlightInsertIntoBasket: function toggleHighlightInsertIntoBasket($wrapper) {
        var _this = this;

        if (!$wrapper.hasClass('item-wrapper-selected')) {
            if($wrapper.find('.item-plan-intervals-prices input:checked').length) {
                $wrapper.addClass('item-wrapper-preselected');
            } else {
                $wrapper.removeClass('item-wrapper-preselected');
            }
        }

        return _this;
    },

    setUserMultidayInput: function setUserMultidayInput($interval) {
        var _this = this;

        $interval.find('.item-plan-multiday-interval__button').hide();
        $interval.find('.item-plan-multiday-interval__days-input').show();
        $interval.find('.item-plan-multiday-interval__days-input input').focus();

        return _this;
    },

    changeItemMultidayDays: function changeItemMultidayDays($interval) {
        var _this = this;

        var $days = $interval.find('.item-plan-multiday-interval__days-input input');

        if (validateInputs($days, ['integer', 'not_empty', 'positive'], '.item-plan-multiday-interval__days-input')) {
            var days = parseInt($days.val());
            var $wrapper = $interval.closest('.item-wrapper');
            var $intervalRadio = $interval.find(':radio');
            var date = strToDateEn($intervalRadio.data('date_from'));
            date = incDate(date, days - 1);
            date = formatDateEn(date);
            $wrapper.data('date_to', date);
            $intervalRadio.data('date_to', date).prop('checked', true).change();
        } else {
            $days.val('');

            var modal = services.get('modal');
            modal.open({
                width: 'md',
                height: 'auto',
                title: services.get('translator').trans('MultidayIntervalDaysIsNotValid'),
                content: services.get('translator').trans('MultidayIntervalDaysIsNotValidHelp')
            });
        }

        return _this;
    },

    selectItemPlanInterval: function selectItemPlanInterval($interval) {
        var _this = this;

        var $wrapper = $interval.closest('.item-wrapper');

        //nejdrive zkusime vybrat intervaly uvnitr ohraniceni
        _this.autoSelectBounderedIntervals($interval, true);
        _this.autoSelectBounderedIntervals($interval, false);

        //pote overime minimum vybranych intervalu a pripadne nastavime minimum
        if (_this.autoSelectMinimumIntervalsAndValid($interval)) {
            _this.reloadItemPlanIntervals($wrapper);
        } else {
            //neni validni, zobrazime zpravu a zrusime vyber
            $interval.find('input').prop('checked', false);
            $wrapper.find('.item-plan-intervals-prices-wrapper').addClass('border-error');
            setTimeout(function () {
                $wrapper.find('.item-plan-intervals-prices-wrapper').removeClass('border-error');
            }, 1500);

            var modal = services.get('modal');
            modal.open({
                width: 'md',
                height: 'auto',
                title: services.get('translator').trans('IntervalSelectionIsNotValid'),
                content: sprintf(services.get('translator').trans('IntervalSelectionIsNotValidHelp'), $interval.find('input').data('product_min_order_count'))
            });
        }

        return _this;
    },

    selectItemMultidayInterval: function selectItemMultidayInterval($multidayInterval) {
        var _this = this;

        var $wrapper = $multidayInterval.closest('.item-wrapper');

        if ($wrapper.hasClass('item-wrapper-selected')) {
            _this.addItemToBasket($wrapper, $multidayInterval.find('input').data('date_to'));
        } else {
            _this.reloadItemPlanIntervals($wrapper, $multidayInterval.find('input').data('date_to'));
        }

        return _this;
    },

    removeItemPlanIntervals: function removeItemPlanIntervals($intervalsWrapper) {
        var _this = this;

        var $wrapper = $intervalsWrapper.closest('.item-wrapper');

        if ($intervalsWrapper.hasClass('item-plan-interval-price-wrapper-all-windows')) {
            //pokud mam zvoleny cely den, tak musim odstranit trochu jinak
            $wrapper.find('.item-plan-interval-all-windows').find('input').prop('checked', false);
        } else {
            //ostatni intervaly mazu normalne
            $intervalsWrapper.closest('td').find('input').prop('checked', false);
        }

        //pokud mam neco v kosiku, tak vymazu
        if(services.has('basketPreview') && $wrapper.hasClass('item-wrapper-selected')) {
            //vymazani nam zaroven prenacte katalog
            var url = $intervalsWrapper.find('.item-plan-interval-price-remove').attr('href');
            var $intervalsPricesWrapper = $wrapper.find('.item-plan-intervals-prices-wrapper');

            blockElement($intervalsPricesWrapper);
            services.get('basketPreview').removeBasketItems(url, function () {
              unBlockElement($intervalsPricesWrapper);
            });
        } else {
            //pokud ne, tak jen prenactu
            _this.reloadItemPlanIntervals($wrapper);
        }

        return _this;
    },

    autoSelectBounderedIntervals: function autoSelectBounderedIntervals($interval, reverseItems) {
        var _this = this;

        var $intervalInput = $interval.find('input');
        var $wrapper = $interval.closest('.item-wrapper');

        var found = false;
        var $searchedInterval = null;
        var $itemPlanIntervals = $wrapper.find('.item-plan-intervals-prices-wrapper').find('.item-plan-interval');
        var $itemPlanIntervalsPom = $($itemPlanIntervals.get());
        if (reverseItems) {
            $itemPlanIntervalsPom = $($itemPlanIntervalsPom.get().reverse());
        }

        $itemPlanIntervalsPom.each(function () {
            var $itemPlanInterval = $(this);

            if (found) {
                var $input = $itemPlanInterval.find('input');
                if ($input.length) {
                    //pokud jsem jiz nalezl input, tak hledam dalsi vybrany, ktery bude pocatkem ohraniceneho intervalu
                    if ($input.is(':checked') && $input.data('product_id') === $intervalInput.data('product_id')) {
                        found = false;
                        $searchedInterval = $itemPlanInterval;
                    }
                } else {
                    found = false;
                }
            }

            if ($itemPlanInterval.is($interval)) {
                found = true;
            }
        });

        if ($searchedInterval) {
            var firstIndex = reverseItems ? $itemPlanIntervals.index($searchedInterval) : $itemPlanIntervals.index($interval);
            var lastIndes = reverseItems ? $itemPlanIntervals.index($interval) : $itemPlanIntervals.index($searchedInterval);

            for(var i = firstIndex; i <= lastIndes; i++) {
                $itemPlanIntervals.eq(i).find('input').prop('checked', true);
            }
        }

        return _this;
    },

    autoSelectMinimumIntervalsAndValid: function autoSelectMinimumIntervalsAndValid($interval) {
        var $intervalInput = $interval.find('input');
        var productMinOrderCount = !isEmpty($intervalInput.data('product_min_order_count')) ? $intervalInput.data('product_min_order_count') : 0;
        if (productMinOrderCount > 1) {
            var $wrapper = $interval.closest('.item-wrapper');

            var found = false;
            var $itemPlanIntervals = $wrapper.find('.item-plan-intervals-prices-wrapper').find('.item-plan-interval');

            var selectedIntervals = $interval.find('input').is(':checked') ? 1 : 0;
            $($itemPlanIntervals.get().reverse()).each(function () {
                var $itemPlanInterval = $(this);

                if (found) {
                    var $input = $itemPlanInterval.find('input');

                    //pokud jsem jiz nalezl input, tak overim minimum vybranych intervalu, pokud neni neco vybraneho, tak koncim
                    if ($input.length && $input.is(':checked') && $input.data('product_id') === $intervalInput.data('product_id')) {
                        selectedIntervals++;
                    } else {
                        found = false;
                    }
                }

                if ($itemPlanInterval.is($interval)) {
                    found = true;
                }
            });

            if (selectedIntervals < productMinOrderCount) {
                var isValid = true;
                var intervalIndex = $itemPlanIntervals.index($interval);
                var autoDirection = 1;

                //nejdrive zvalidujeme - overime, ze opravdu budeme mit minimum intervalu
                for(var i = 1; i <= productMinOrderCount - selectedIntervals; i++) {
                    var $input = $itemPlanIntervals.eq(intervalIndex + i).find('input');
                    if(!$input.length || $input.data('product_id') !== $intervalInput.data('product_id')) {
                        isValid = false;
                        break;
                    }
                }

                if(!isValid) {
                    isValid = true;
                    autoDirection = -1;
                    for(i = 1; i <= productMinOrderCount - selectedIntervals; i++) {
                        var $input1 = $itemPlanIntervals.eq(intervalIndex + i * autoDirection).find('input');
                        if(!$input1.length || $input1.data('product_id') !== $intervalInput.data('product_id')) {
                            isValid = false;
                            break;
                        }
                    }
                }

                if(isValid) {
                    //pokud je validni, tak predvybereme
                    for(i = 1; i <= productMinOrderCount - selectedIntervals; i++) {
                        $itemPlanIntervals.eq(intervalIndex + i * autoDirection).find('input').prop('checked', true);
                    }
                    return true;
                }
            } else {
                return true;
            }
        } else {
            return true;
        }

        return false;
    },

    reloadItemPlanIntervals: function reloadItemPlanIntervals($wrapper, dateToOverride) {
        var _this = this;

        var itemId = $wrapper.data('id');
        var dateFrom = $wrapper.data('date_from');
        var dateTo = $wrapper.data('date_to');

        if (!isEmpty(dateToOverride)) {
            dateTo = dateToOverride;
        } else {
            dateTo = dateFrom;
        }

        var intervalIds = [];
        if($wrapper.find('.item-plan-intervals-prices input').length === 1) {
            intervalIds.push($wrapper.find('.item-plan-intervals-prices input').val());
        } else {
            $wrapper.find('.item-plan-intervals-prices input:checked').each(function () {
                intervalIds.push($(this).val());
            });
        }

        if(itemId && dateFrom && dateTo) {
            var $intervalsPricesWrapper = $wrapper.find('.item-plan-intervals-prices-wrapper');

            blockElement($intervalsPricesWrapper);
            $.getCORS(services.get('configurations').param('DomainURL') + '/?action=catalog&method=js_get_item_plan_intervals_prices&id=' + itemId + '&date_from=' + dateFrom + '&date_to=' + dateTo + '&interval_id[]=' + intervalIds.join('&interval_id[]='), function (res) {
                unBlockElement($intervalsPricesWrapper);

                try {
                    res = JSON.parse(res);

                    if(res.msg === 'SUCCESS') {
                        $intervalsPricesWrapper.replaceWith(res.data.html);

                        $wrapper.data('date_to', dateTo);

                        _this.toggleHighlightInsertIntoBasket($wrapper);
                    } else if (res.msg === 'NOT_AVAILABLE') {
                        $intervalsPricesWrapper.replaceWith(res.data.html);

                        var modal = services.get('modal');
                        modal.open({
                            width: 'md',
                            height: 'auto',
                            title: services.get('translator').trans('LoadItemPlanIntervalsNotAvailable'),
                            content: services.get('translator').trans('LoadItemPlanIntervalsNotAvailableHelp')
                        });
                    } else {
                        services.get('development').viewSiteErrorMsg(res);
                    }
                } catch(e) {
                    services.get('development').viewSiteErrorMsg(res, e);
                }
            });
        }

        return _this;
    },

    addItemToBasket: function addItemToBasket($wrapper, dateToOverride) {
        var _this = this;

        var itemId = $wrapper.data('id');
        var dateFrom = $wrapper.data('date_from');
        var dateTo = $wrapper.data('date_to');
        var isPurchase = $wrapper.data('direct_purchase');
                
        isPurchase = isPurchase === 1;

        if (!isEmpty(dateToOverride)) {
            dateTo = dateToOverride;
        } else {
            if (isEmpty(dateTo)) {
                dateTo = dateFrom;
            }
        }

        var intervalIds = [];
        if($wrapper.find('.item-plan-intervals-prices input').length === 1) {
            intervalIds.push($wrapper.find('.item-plan-intervals-prices input').val());
        } else {
            $wrapper.find('.item-plan-intervals-prices input:checked').each(function () {
                intervalIds.push($(this).val());
                if ($(this).closest('.item-plan-multiday-interval').length === 0) {
                    dateTo = dateFrom;
                }
            });
        }
        var groupId = null;
        if(services.get('configurations').param('ReservationType') === 'CAPACITY') {
            groupId = $wrapper.find('.item-capacity input:checked').val();
        } else {
            groupId = -1;
        }

        var catalogFilterItemId = $('.catalog-filter').find('.catalog-filter-item-id').val();

        if(itemId && ((intervalIds.length > 0 && dateFrom && dateTo && groupId) || isPurchase)) {
            blockElement($wrapper);
            $.getCORS(services.get('configurations').param('DomainURL') + '/?action=basket&method=js_add_basket_item&id=' + itemId + '&date_from=' + dateFrom + '&date_to=' + dateTo + '&interval_id[]=' + intervalIds.join('&interval_id[]=') + '&group_id=' + groupId  + '&catalog_filter_item_id=' + catalogFilterItemId, function (res) {
                unBlockElement($wrapper);
                try {
                    res = JSON.parse(res);

                    if(res.msg === 'SUCCESS') {
                        //vse v poradku

                        if (services.has('basketPreview')) {
                            services.get('basketPreview').loadBasketPreview();
                        }

                        if (services.has('catalogFilterBasketItems')) {
                            services.get('catalogFilterBasketItems').loadCatalogFilterBasketItems();
                        }
                    } else if (res.msg === 'NOT_AVAILABLE') {
                        //neni neco dostupne

                        var modal = services.get('modal');
                        modal.open({
                            width: 'md',
                            height: 'auto',
                            title: services.get('translator').trans('AddItemToBasketNotAvailable'),
                            content: services.get('translator').trans('AddItemToBasketNotAvailableHelp')
                        });
                    } else {
                        //services.get('development').viewSiteErrorMsg(res);
                        
                        var modal1 = services.get('modal');
                        modal1.open({
                            width: 'md',
                            height: 'auto',
                            title: services.get('translator').trans('AddItemToBasketNotAvailable'),
                            content: services.get('translator').trans('AddItemToBasketNotAvailableHelp')
                        });                        
                    }

                    if (services.has('catalogFilter')) {
                        services.get('catalogFilter').doItemsSearch();
                    }
                } catch(e) {
                    services.get('development').viewSiteErrorMsg(res, e);
                }
            });
        } else {
            $wrapper.find('.item-plan-intervals-prices-wrapper').addClass('border-error');
            setTimeout(function () {
                $wrapper.find('.item-plan-intervals-prices-wrapper').removeClass('border-error');
            }, 1500);
        }

        return _this;
    },

    init: function init() {
        var _this = this;

        _this.$container = $('#' + _this.containerID);
        _this.registerCallbacks();

        return _this;
    }
});
